import { api } from '@/lib/api'
import type {
  AssociateTotpResponse,
  MfaEnrollStartResponse,
  MfaMessageResponse,
  MfaStatus,
  SigninResponse,
} from './types'

export const securityApi = {
  getMfaStatus: () => api.get<MfaStatus>('/api/auth/cognito/mfa-status'),

  // Password re-auth path (cognito users) - uses the PUBLIC signin endpoint
  // NOT the App JWT flow because we need a fresh Cognito AccessToken.
  reauthCognito: (email: string, password: string) =>
    api.post<SigninResponse>('/api/auth/cognito/signin', { email, password }),

  associateTotp: (accessToken: string, email: string) =>
    api.post<AssociateTotpResponse>('/api/auth/cognito/associate-totp', {
      accessToken,
      email,
    }),

  verifyTotp: (accessToken: string, userCode: string, email: string) =>
    api.post<MfaMessageResponse>('/api/auth/cognito/verify-totp', {
      accessToken,
      userCode,
      email,
    }),

  // Social (OAuth) users - skip the password step.
  mfaEnrollStart: () =>
    api.post<MfaEnrollStartResponse>('/api/auth/cognito/mfa-enroll/start', {}),

  mfaEnrollVerify: (enrollmentToken: string, userCode: string) =>
    api.post<MfaMessageResponse>('/api/auth/cognito/mfa-enroll/verify', {
      enrollmentToken,
      userCode,
    }),

  // password is omitted for social users; backend accepts both shapes.
  disableTotp: (userCode: string, password?: string) =>
    api.post<MfaMessageResponse>(
      '/api/auth/cognito/disable-totp',
      password ? { userCode, password } : { userCode },
    ),
}
